import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getFirestore, type Firestore } from 'firebase/firestore';

/**
 * Public web config for project wizardarenagame. Safe to ship in the client.
 * Override with VITE_FIREBASE_* if you point a local build at another project.
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDH7Vhuoc1VjWPLaJNasBNaSLVY45aTYbM',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'wizardarenagame.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'wizardarenagame',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'wizardarenagame.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '253707917139',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:253707917139:web:f7c76eefd1e15f83c773a6',
};

let app: FirebaseApp | null = null;
let db: Firestore | null = null;

export function firebaseApp(): FirebaseApp | null {
  if (app) return app;
  if (!firebaseConfig.apiKey || !firebaseConfig.projectId) return null;
  try {
    app = getApps()[0] ?? initializeApp(firebaseConfig);
    return app;
  } catch (err) {
    console.warn('firebase init failed', err);
    return null;
  }
}

export function firestore(): Firestore | null {
  if (db) return db;
  const ready = firebaseApp();
  if (!ready) return null;
  try {
    db = getFirestore(ready);
    return db;
  } catch (err) {
    console.warn('firestore init failed', err);
    return null;
  }
}

export const firebaseProjectId = firebaseConfig.projectId;
